import api from "./api";
import { buildQueryParams } from "../utils/buildQueryParams";

class ExperienciasService {
  async getExclusiveExperiences(params){
    const queryParams = buildQueryParams(params);
    return api.get(`v1/api/exclusive-experiences?${queryParams}`);
  }
  async getExclusiveExperience(contentTitle) {
    return api.get(`v1/api/exclusive-experiences/${contentTitle}`);
  }
  async exclusiveExperiencesRegister(request) {
    const { id, answer, json } = request;
    return api.post('v1/api/exclusive-experiences/'+id+'/register', {answer: answer, json: json});
  }
}

export default new ExperienciasService();
